import { useEffect } from "react";
import Button from "../../components/common/Button";
import { Link, Navigate } from "react-router-dom";
import AuthUITemplate from "./AuthUI";
import { useSignup } from "react-redux-django-auth";
import useAuthRedirect from "../../hooks/useAuthRedirect";
import { useToast } from "../../hooks/otherHooks/useToast";
import GoogleAuthHandler from "./GoogleAuthHandler";
import Input from "../../components/common/Input";
import { User, Mail, Phone, Lock } from "lucide-react";

const SignUp = () => {
  // Initial Data
  const initialFormData = {
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    password: "",
    re_password: "",
  };

  const { error, formData, isStatus201, loading, onChange, onSubmit } =
    useSignup(initialFormData, null);

  //Toast
  const { showToast, redirectPage } = useAuthRedirect(isStatus201);

  const { addToast } = useToast();

  useEffect(() => {
    if (showToast) {
      addToast({
        message:
          "Account Created. Confirmation email has been sent to your email account.",
        bg: "success",
      });
    }
  }, [showToast, addToast]);

  if (redirectPage) {
    return <Navigate to="/login" />;
  }

  return (
    <AuthUITemplate title="Join the Journey" errorMsg={error}>
      <form className="cht-space-y-3" onSubmit={(e) => onSubmit(e)}>
        {/* Name Grid */}
        <div className="cht-grid cht-grid-cols-2 cht-gap-3">
          <Input
            label="First Name"
            labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
            type="text"
            id="first_name"
            name="first_name"
            placeholder="John"
            leftIcon={<User size={18} />}
            value={formData.first_name}
            onChange={(e: any) => onChange(e)}
            required
          />
          <Input
            label="Last Name"
            labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
            type="text"
            id="last_name"
            name="last_name"
            placeholder="Doe"
            leftIcon={<User size={18} />}
            value={formData.last_name}
            onChange={(e: any) => onChange(e)}
            required
          />
        </div>

        {/* Contact Info */}
        <Input
          label="Email Address"
          labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
          type="email"
          id="email"
          name="email"
          placeholder="john@example.com"
          leftIcon={<Mail size={18} />}
          value={formData.email}
          onChange={(e: any) => onChange(e)}
          required
        />

        <Input
          label="Phone Number"
          labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
          type="tel"
          id="phone_number"
          name="phone_number"
          placeholder="+234..."
          leftIcon={<Phone size={18} />}
          value={formData.phone_number}
          onChange={(e: any) => onChange(e)}
          required
        />

        {/* Passwords */}
        <div className="cht-grid cht-grid-cols-1 md:cht-grid-cols-2 cht-gap-3">
          <Input
            label="Create Password"
            labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
            type="password"
            id="password"
            name="password"
            placeholder="••••••••"
            leftIcon={<Lock size={18} />}
            value={formData.password}
            onChange={(e: any) => onChange(e)}
            required
          />

          <Input
            label="Confirm Password"
            labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
            type="password"
            id="re_password"
            name="re_password"
            placeholder="••••••••"
            leftIcon={<Lock size={18} />}
            value={formData.re_password}
            onChange={(e: any) => onChange(e)}
            required
          />
        </div>

        <Button
          type="submit"
          variant="primary"
          size="lg"
          fullWidth
          isLoading={loading}
          disabled={loading}
          className="cht-w-full cht-mt-4 cht-py-4 cht-uppercase cht-tracking-widest cht-text-xs cht-rounded-2xl"
        >
          Create Account
        </Button>
      </form>

      <div className="cht-relative cht-my-6 cht-flex cht-items-center cht-justify-center">
        <div className="cht-absolute cht-inset-0 cht-flex cht-items-center">
          <div className="cht-w-full cht-border-t cht-border-white/10"></div>
        </div>
        <span className="cht-relative cht-bg-transparent cht-px-4 cht-text-[9px] cht-font-black cht-text-white/40 cht-uppercase cht-tracking-widest">or</span>
      </div>

      <div className="cht-space-y-6">
        <GoogleAuthHandler />
        <p className="cht-text-center cht-text-[11px] cht-font-medium cht-text-white/60">
          Already have an account?{" "}
          <Link to="/login" className="cht-text-white cht-font-black hover:cht-underline cht-ml-1">Log In</Link>
        </p>
      </div>
    </AuthUITemplate>
  );
};

export default SignUp;
